// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bqEtO","question":"styles_question__3ZyPU","description":"styles_description__3FgmC"};